import { TimelineIconStages } from '@/constants/enum';

export interface ITimelineStage {
  id: TimelineIconStages;
  fieldTitle: 'timeline_order_step_title' | 'timeline_ship_step_title' | 'timeline_delivery_step_title';
  fieldTooltip: 'timeline_order_step_description' | 'timeline_ship_step_description' | 'timeline_delivery_step_description';
  fieldStatus: 'timeline_order_step_enable' | 'timeline_ship_step_enable' | 'timeline_delivery_step_enable';
}

export const timelineStages: ITimelineStage[] = [
  {
    id: TimelineIconStages.Stage1,
    fieldTitle: 'timeline_order_step_title',
    fieldTooltip: 'timeline_order_step_description',
    fieldStatus: 'timeline_order_step_enable',
  },
  {
    id: TimelineIconStages.Stage2,
    fieldTitle: 'timeline_ship_step_title',
    fieldTooltip: 'timeline_ship_step_description',
    fieldStatus: 'timeline_ship_step_enable',
  },
  {
    id: TimelineIconStages.Stage3,
    fieldTitle: 'timeline_delivery_step_title',
    fieldTooltip: 'timeline_delivery_step_description',
    fieldStatus: 'timeline_delivery_step_enable',
  },
];
